import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Colaborador } from 'src/app/shared/models/colaborador.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-colaborador-authentication-form',
  templateUrl: './colaborador-authentication-form.component.html',
  styleUrls: ['./colaborador-authentication-form.component.scss']
})
export class ColaboradorAuthenticationFormComponent implements OnInit {

  colaborador: Colaborador = new Colaborador();

  @Input()
  loading = false;

  @Output()
  login: EventEmitter<Colaborador> = new EventEmitter<Colaborador>();

  fieldsWithFocus = [];

  showPassword = false;

  constructor() { }

  ngOnInit(): void { }

  handleLogin(): void {
    this.login.emit(this.colaborador);
  }

  setFocus(fieldname: string) {
    this.fieldsWithFocus.push(fieldname);
  }

  removeFocus(fieldname: string) {
    this.fieldsWithFocus = this.fieldsWithFocus.filter((field) => field !== fieldname);
  }

  hasFocus(fieldname: string) {
    return this.fieldsWithFocus.includes(fieldname);
  }

  clearField(control: any, fieldName: string) {
    control.setValue('');
    this.removeFocus(fieldName);
  }
}
